import React from 'react';
import PropTypes from 'prop-types';

import { formatDate } from '../../../../utils/dateFunctions';
import CloseButton from '../../../formElements/CloseButton';
import StaticField from '../../../formElements/StaticField';

import form from '../../../../commonStyles/formStyles.module.css';
import expand from '../../../../commonStyles/rowExpand.module.css';

const T2DRHealthDataRowDetails = ({ row, onClose }) => {
    return (
        <div className={expand.rowDropdown}>
            <form className={form.formWrapper}>
                <div className={form.formSection}>
                    <div className={form.formColumn}>
                        <StaticField
                            id="previouslySuppliedFibreSupplements"
                            label="Previously Supplied Fibre Supplements"
                            content={row.previouslySuppliedFibreSupplements || ' - '}
                            customClass="info"
                        />
                        <StaticField
                            id="actualTdrStartDate"
                            label="Actual TDR Start Date"
                            content={formatDate(row.actualTdrStartDate) || ' - '}
                            customClass="dateInfo"
                        />
                    </div>
                    <div className={form.formColumn}>
                        <StaticField
                            id="linkedModule"
                            label="Linked Module"
                            content={row.linkedModule || ' - '}
                            customClass="info"
                        />
                    </div>
                </div>
            </form>
            <CloseButton id="t2drRowDetailButton" onClose={onClose} />
        </div>
    );
};

T2DRHealthDataRowDetails.propTypes = {
    row: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};

export default T2DRHealthDataRowDetails;
